<template>
    <div class="tw-animate-pulse tw-flex tw-full tw-mt-3">
        <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-full tw-h-[22px]" ></div>
    </div>
</template>
